// extracted by mini-css-extract-plugin
module.exports = {"container":"topp_container__3a_22","middle":"topp_middle__1t8KE","image":"topp_image__IlXtX","text":"topp_text__1TX4T","customfileinput":"topp_customfileinput__3X0Oh"};